'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var main = require('../../node_modules/ngeohash/main.js');

var DEFAULT_GEOCODER_COMPONENTS_MAP = {
  country: ['short_name', 'country'],
  administrative_area_level_1: ['short_name', 'state'],
  administrative_area_level_2: ['long_name', 'county'],
  locality: ['long_name', 'city'],
  postal_town: ['long_name', 'city'],
  postal_code: ['long_name', 'postalCode'],
  postal_code_suffix: ['long_name', 'postalCodeSuffix'],
  subpremise: ['long_name', 'subpremise'],
  route: ['long_name', 'street'],
  street_number: ['long_name', 'streetNumber']
};
/**
 * Parses and interprets the results from a Google Maps Places geocoder query.
 *
 * @param {*} results
 * @returns
 */

function parseGeocoderResults(results) {
  var componentsMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_GEOCODER_COMPONENTS_MAP;
  var place = results === null || results === void 0 ? void 0 : results[0];

  if (!place) {
    return;
  } // Construct Geopoint


  var latitude = place.geometry.location.lat();
  var longitude = place.geometry.location.lng();
  var geohash = main.encode(latitude, longitude);
  var geopoint = {
    latitude,
    longitude,
    geohash
  }; // Formatted Address

  var formattedAddress = place.formatted_address; // Place id

  var placeId = place.place_id; // Components

  var components = {};

  for (var component of place.address_components) {
    var _componentsMap$key, _component$nameType;

    var key = component === null || component === void 0 ? void 0 : component.types[0];
    var [nameType, name] = (_componentsMap$key = componentsMap[key]) !== null && _componentsMap$key !== void 0 ? _componentsMap$key : []; // Skip components not in `componentMap`

    if (name === undefined) {
      continue;
    }

    var value = (_component$nameType = component === null || component === void 0 ? void 0 : component[nameType]) !== null && _component$nameType !== void 0 ? _component$nameType : '';
    components[name] = value;
  }

  return {
    geopoint,
    formattedAddress,
    placeId,
    components
  };
}

exports.parseGeocoderResults = parseGeocoderResults;
